import React from "react";
import {
    Button, 
    TableCell, 
    Table, 
    TableHead, 
    TableRow, 
    TableBody,
    TableFooter
} from '@mui/material'
import Bookings from '../../../models/Bookings';
import AddCostModal from './AddCostModal'
import EventCosts from '../../../models/EventCosts';
import EditIcon from '@mui/icons-material/Edit'
import ClearIcon from '@mui/icons-material/Clear'

class AccountingEvent extends React.Component<any, any> {

    componentDidMount() {
        this.props.fetchBookings()
        this.props.fetchCosts()
    }

    public render() {
    const columnNames: string[] = ['Beschreibung', 'Einnahmen', 'Ausgaben', 'Aktionen']

    let tableColumns = columnNames.map(x => {
        return <TableCell>{x}</TableCell>
    })

    const incomeOverall = (this.props.bookings as Bookings[]).reduce((sum ,x) => {
        let currentValue = 0

        if(x.bookingAlternativePrice !== null)
            currentValue = x.bookingAlternativePrice
        else if(x.bookingTotal !== null)
            currentValue = x.bookingTotal

        return sum + currentValue
    }, 0)

    const costOverall = (this.props.costs as EventCosts[]).reduce((sum, x) => sum + (x.expenditureAmount !== null ? x.expenditureAmount : 0), 0)

    let rowIncome = <TableRow>
        <TableCell>Teilnehmerbeiträge</TableCell>
        <TableCell>{`€ ${incomeOverall.toFixed(2).replace('.',',')}`}</TableCell>
        <TableCell>€ 0,-</TableCell>
        <TableCell></TableCell>
    </TableRow>

    let rowsCosts = (this.props.costs as EventCosts[]).map(x => {
        return <TableRow key={x.id}>
            <TableCell>{x.expenditureDescription}</TableCell>
            <TableCell>€ 0,-</TableCell>
            <TableCell>{`€ ${x.expenditureAmount.toFixed(2).replace('.',',')}`}</TableCell>
            <TableCell><EditIcon 
                        className='icon' 
                        onClick={() => {
                            this.props.showModal()
                            this.props.changeNewCostObject(x)
                            this.props.changeMethod('Edit')
                    }}/>
                    <ClearIcon className='icon' onClick={() => this.props.delete(x.id)}/></TableCell>
        </TableRow>
    })

    let totalRow = <TableRow>
        <TableCell><b className='tableFooter'>Einnahmen / Ausgaben</b></TableCell>
        <TableCell><b className='tableFooter'>{`€ ${incomeOverall.toFixed(2).replace('.',',')}`}</b></TableCell>
        <TableCell><b className='tableFooter'>{`€ ${costOverall.toFixed(2).replace('.',',')}`}</b></TableCell>
    </TableRow>

    let balanceRow = <TableRow>
        <TableCell><b className='tableFooter'>Gesamtsumme</b></TableCell>
        <TableCell></TableCell>
        <TableCell><b className='tableFooter'>{`€ ${(incomeOverall - costOverall).toFixed(2).replace('.', ',')}`}</b></TableCell>
    </TableRow>

    return (
        <div className='card'>
            <div className='card-header'>
                Abrechnung
            </div>
            <div className='card-body'>
                <div className='row'>
                    <div className='col-sm-2'>
                        <b>Kosten hinzufügen</b>
                    </div>
                    <div className='col-sm-2'>
                        <Button variant='contained' color='primary' className='btnBlue' onClick={() => this.props.showModal()}>Hinzufügen</Button>
                    </div>
                </div>
                <div className='row mt-3'>
                    <Table className="objects-table table">
                        <TableHead>
                            <TableRow>
                                {tableColumns}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rowIncome}
                            {rowsCosts}
                        </TableBody>
                        <TableFooter>
                            {totalRow}
                            {balanceRow}
                        </TableFooter>
                    </Table>
                </div>
            </div>
            {
                this.props.modal &&
                <AddCostModal 
                    hide={this.props.hideModal}
                    newCost={this.props.newCost}
                    change={this.props.changeNewCost}
                    submit={this.props.submit}
                    validRequiredFields={this.props.validRequiredFields}
                />
            }
        </div>
    )
}
}

export default AccountingEvent